export { default } from "./Divider-component";
